<template>
  <v-sheet color="transparent" class="d-flex justify-space-between mb-4" v-if="district">
    <v-sheet v-on:click="back_to_districts" class="mr-3 pa-2 d-flex justify-center align-center my-back-btn" rounded="xl" style="cursor: pointer">
      <v-icon :icon="['fas', 'angles-left']" />
    </v-sheet>
    <v-alert color="transparent" rounded="xl" style="position: relative">
      <v-img width="100%" height="100%" style="z-index: -1; position: absolute; top: 0; left: 0; filter: blur(200px); background: #fff !important;"
             :src="`https://media.scgrdn.pro/boss/app_zn/district/${district.guid}.png`" cover
      />
      <v-sheet color="transparent" class="d-flex justify-space-between align-center">
        <v-sheet height="80" :width="district.region.flag ? 230 : 120" color="transparent" class="d-flex">
          <v-img
              v-if="district.region.flag"
              height="80"
              width="150"
              class="rounded-s-xl rounded-e-0"
              :src="district.region.flag"
              cover
          />
          <v-img
              :class="{'rounded-s-0' : district.region.flag, 'rounded-xl' : !district.region.flag}"
              class="rounded-e-xl"
              height="80"
              width="80"
              :src="`https://media.scgrdn.pro/boss/app_zn/district/${district.guid}.png`"
              cover
          />
        </v-sheet>

        <v-sheet class="d-flex justify-space-between flex-column ml-2" height="100%" color="transparent">
          <p class="font-weight-bold">{{ district.district.name }}</p>
          <p>{{ district.chief.name }}</p>
          <p v-if="district.region.name">
            {{ district.region.name }}
          </p>
          <p v-else class="font-weight-bold" style="color: #b24509">РЕГИОН НЕ УКАЗАН</p>
        </v-sheet>

        <v-spacer />
        <v-btn variant="text" :icon="true" rounded="xl" flat size="small" density="comfortable" v-if="!(year <= parseInt(moment().format('YYYY')))" v-on:click="prev_year">
          <v-icon :icon="['fas', year > parseInt(moment().format('YYYY')) ? 'arrow-left' : 'xmark']" />
        </v-btn>
        <v-avatar color="transparent">
          <p class="text-center font-weight-bold mb-1">{{ year }}</p>
        </v-avatar>
        <v-btn variant="text" rounded="xl" :icon="true" flat size="small" density="comfortable" v-on:click="next_year">
          <v-icon :icon="['fas', 'arrow-right']" />
        </v-btn>
      </v-sheet>
    </v-alert>
  </v-sheet>

  <v-row class="text-center">
    <v-col v-slot:default="available = check_quarter(current_quarter, i)" v-for="i in 4" :key="i">
      <v-sheet style="cursor: pointer" :style="`opacity: ${available ? '1' : '0.2'}`" :color="get_quarter_color(i)" rounded="xl" height="100px" v-on:click="open_period(i)">
        КВАРТАЛ {{ i }}
        <template v-if="available">
          <v-sheet v-if="is_current(i)" color="transparent" class="mx-2" rounded="xl">ТЕКУЩИЙ</v-sheet>
        </template>
        <template v-else>
          <v-sheet color="transparent" class="mx-2" rounded="xl">КВАРТАЛ ЗАКРЫТ ДЛЯ ПЛАНИРОВАНИЯ</v-sheet>
        </template>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import { CurrentYear } from "@/store/zn_planner/CurrentYear"
import { CurrentYearCalendar } from "@/store/zn_planner/CalendarOfYear"
import { TokenGUIDStore } from "@/store/global/SessionStore"
import route_check from "@/libs/route_check";
import {CurrentDistrict} from "@/store/zn_planner/CurrentDistrict";

export default {
  name: 'A_Planner_Y',
  async beforeMount() {
    route_check('/autoplanner/district').then(async res => {
      if (res) {
        this.year = parseInt(this.$route.params.year)
        this.check_guid()
        await this.get_district_data()
      } else {
        this.$router.push({ name: 'home' })
      }
    })
  },
  data() {
    return {
      inside: false,
      drawer: false,
      segment: null,
      period: null
    }
  },
  methods: {
    moment,
    get_district_data: async function () {
      this.district = null
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.ONETEST}/GetDistrictData`
      let raw = {
        district: this.$route.params.guid
      }

      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify(raw)
      }
      await fetch(url, properies)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка получения Документов!`
            }
          })
          .then(result => {
            this.district = result
          }).catch(err => {
            console.error(err)
          })
    },
    is_current: function (quarter) {
      return quarter === this.current_quarter && this.$route.params.year === moment().format('YYYY')
    },
    get_quarter_color: function (quarter) {
      if (quarter === this.current_quarter && this.$route.params.year === moment().format('YYYY')) {
        return 'green'
      } else {
        let available = this.check_quarter(this.current_quarter, quarter)
        if (available) {
          return 'green-lighten-4'
        } else {
          return 'grey-lighten-4'
        }
      }
    },
    back_to_districts: function () {
      this.$router.push({ name: 'a__planner__district' })
    },
    check_guid: function () {
      if (!this.$route.params.guid || !this.$route.params.year) {
        this.$router.push({ name: 'a__planner__district' })
      } else if (this.$route.params.year < parseInt(moment().format('YYYY'))) {
        this.year = parseInt(moment().format('YYYY'))
      }
    },
    check_quarter: function (current, position) {
      if (this.year > parseInt(moment().format('YYYY'))) {
        return true
      } else if (this.year === parseInt(moment().format('YYYY'))) {
        return parseInt(current) <= position;
      } else if (this.year < parseInt(moment().format('YYYY'))) {
        return false
      }
    },
    next_year: async function () {
      this.year++
      // await this.get_prod_calendar()
    },
    prev_year: async function () {
      this.year--
      // await this.get_prod_calendar()
    },
    update_route: function () {
      this.$router.replace({ name: 'a__planner__y', params: { year: this.year, guid: this.$route.params.guid }})
    },
    open_period: function ( segment ) {
      this.$router.push({ name: 'a__planner__q', params: { quarter: segment, year: this.year, guid: this.$route.params.guid } })
    }
  },
  computed: {
    current_quarter() {
      return moment().get('quarter')
    },
    year: {
      get() {
        return CurrentYear().get()
      },
      set(value) {
        CurrentYear().set(value)
        this.update_route()
      }
    },
    calendar: {
      get() {
        return CurrentYearCalendar().get()
      },
      set(value) {
        CurrentYearCalendar().set(value)
      }
    },
    district: {
      get() {
        return CurrentDistrict().get()
      },
      set(value) {
        CurrentDistrict().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  }
}

</script>

<style scoped>
.my-back-btn {
  cursor: pointer;
  transition: 0.3s;
}
.my-back-btn:hover {
  background-color: #dedede;
}
</style>
